// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"573e5259","729":"00344b2b"}[chunkId] + ".css";
};